export default __webpack_public_path__ + "static/media/download.9266653b.svg";